/* LORENS — JS bug fixes (Claude). Loaded after the product page inline script so overrides win. */
(function () {
  function lbOpenCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return false;
    var opener = document.querySelector('[aria-controls="cart-drawer"]');
    if (opener) { opener.click(); return true; }
    try { if (typeof drawer.show === 'function') { drawer.show(); return true; } } catch (e) {}
    drawer.setAttribute('open', '');
    return true;
  }
  window.lbOpenCartDrawer = lbOpenCartDrawer;

  function lbAddVariant(variantId, btn) {
    if (!variantId) return;
    if (btn) { btn.disabled = true; btn.textContent = 'מוסיף...'; }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (btn) btn.textContent = '✓ נוסף!';
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
        try { lbOpenCartDrawer(); } catch (e) {}
        if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = 'הוספה לסל'; }, 2000);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'שגיאה, נסה שוב'; setTimeout(function () { btn.textContent = 'הוספה לסל'; }, 2000); }
      });
  }

  function lbSizeOptionOf(product) {
    return (product.options || []).map(function (o, i) {
      if (typeof o === 'string') return { name: o, position: i + 1, values: null };
      return o;
    }).filter(function (o) {
      var n = (o.name || '').toLowerCase();
      return n.indexOf('size') > -1 || n.indexOf('מידה') > -1 || n.indexOf('מידות') > -1;
    })[0];
  }

  function lbShowSizeChooser(card, product, sizeOpt, triggerBtn) {
    if (!card) return;
    var existing = card.querySelector('.cov-sizes');
    if (existing) { existing.remove(); return; }
    var pos = sizeOpt.position || 1;
    var wrap = document.createElement('div');
    wrap.className = 'cov-sizes';
    wrap.addEventListener('click', function (e) { e.stopPropagation(); });
    var title = document.createElement('div');
    title.className = 'cov-sizes__title';
    title.textContent = 'בחרו מידה:';
    wrap.appendChild(title);
    var list = document.createElement('div');
    list.className = 'cov-sizes__list';
    var values = sizeOpt.values || product.variants.map(function (v) { return v['option' + pos]; });
    var seen = {};
    values.filter(function (v) { if (!v || seen[v]) return false; seen[v] = 1; return true; }).forEach(function (val) {
      var variant = product.variants.filter(function (v) { return v['option' + pos] === val; })[0];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cov-size';
      b.textContent = val;
      if (!variant || !variant.available) {
        b.className += ' is-soldout';
        b.disabled = true;
      } else {
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          lbAddVariant(variant.id, triggerBtn);
          wrap.remove();
        });
      }
      list.appendChild(b);
    });
    wrap.appendChild(list);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cov-sizes__close';
    close.setAttribute('aria-label', 'סגור');
    close.textContent = '×';
    close.addEventListener('click', function (ev) { ev.stopPropagation(); wrap.remove(); });
    wrap.appendChild(close);
    card.appendChild(wrap);
  }

  // Coverflow "add to cart": if the product has size variants, let the customer choose a size first.
  window.lbCovAddToCart = function (btn) {
    if (!btn) return;
    var card = btn.closest('.cov-card') || btn.parentElement;
    var directId = btn.getAttribute('data-variant-id');
    var link = card && card.querySelector('a[href*="/products/"]');
    var href = link ? link.getAttribute('href') : '';
    var handle = '';
    try { handle = href.split('/products/')[1].split('?')[0].split('#')[0]; } catch (e) {}
    if (!handle) { return lbAddVariant(directId, btn); }
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        btn.disabled = false;
        btn.textContent = original;
        var sizeOpt = lbSizeOptionOf(p);
        var avail = p.variants.filter(function (v) { return v.available; });
        if (!sizeOpt || p.variants.length <= 1) {
          return lbAddVariant((avail[0] || p.variants[0]).id, btn);
        }
        lbShowSizeChooser(card, p, sizeOpt, btn);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        lbAddVariant(directId, btn);
      });
  };

  // "הסל שלך" (view cart) button opens the SIDE drawer instead of the /cart page.
  document.addEventListener('click', function (e) {
    var link = e.target && e.target.closest ? e.target.closest('a.button[href]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var url;
    try { url = new URL(href, location.origin); } catch (_) { return; }
    var path = url.pathname.replace(/\/+$/, '');
    if (!/\/cart$/.test(path)) return;
    if (!document.getElementById('cart-drawer')) return;
    e.preventDefault();
    e.stopPropagation();
    lbOpenCartDrawer();
  }, true);
})();

/* ==========================================================================
   F1 — LORENS product-card image carousel controller (Claude, 16.09)
   Swipe on mobile is native (scroll-snap). This wires up the dots (active
   state) and the desktop arrows. Direction-agnostic (RTL-safe) via
   scrollIntoView({inline:'center'}).
   ========================================================================== */
(function () {
  function initCarousel(car) {
    if (!car || car.__lbInit) return;
    car.__lbInit = true;
    var track = car.querySelector('[data-lb-track]');
    var slides = Array.prototype.slice.call(car.querySelectorAll('.lb-carousel__slide'));
    var dots = Array.prototype.slice.call(car.querySelectorAll('.lb-carousel__dot'));
    if (!track || slides.length < 2) return;

    function setActive(i) {
      for (var j = 0; j < dots.length; j++) {
        if (j === i) dots[j].classList.add('is-active');
        else dots[j].classList.remove('is-active');
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            var idx = slides.indexOf(e.target);
            if (idx > -1) setActive(idx);
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }

    function currentIndex() {
      var tr = track.getBoundingClientRect();
      var cx = tr.left + tr.width / 2;
      var best = Infinity, cur = 0;
      for (var i = 0; i < slides.length; i++) {
        var r = slides[i].getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - cx);
        if (d < best) { best = d; cur = i; }
      }
      return cur;
    }

    function go(dir) {
      var target = currentIndex() + dir;
      if (target < 0) target = 0;
      if (target > slides.length - 1) target = slides.length - 1;
      try {
        slides[target].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      } catch (e) {
        slides[target].scrollIntoView(false);
      }
    }

    // F7 (Claude, 3.11): clicking a dot switches to that image instead of opening the product
    function goTo(i) {
      try { slides[i].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }); }
      catch (e) { slides[i].scrollIntoView(false); }
    }
    dots.forEach(function (d, i) {
      d.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(i); });
    });
    var dotsWrap = car.querySelector('.lb-carousel__dots');
    if (dotsWrap) dotsWrap.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });

    var prev = car.querySelector('.lb-carousel__arrow--prev');
    var next = car.querySelector('.lb-carousel__arrow--next');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
  }

  function scan() {
    var list = document.querySelectorAll('lb-card-carousel[data-multi]');
    for (var i = 0; i < list.length; i++) initCarousel(list[i]);
  }

  var t;
  function scanDebounced() { clearTimeout(t); t = setTimeout(scan, 200); }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);

  try {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { scanDebounced(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
